import React from 'react';

export interface CmntOptions {
    theme?: string;
    lang?: string;
    service?: string;
    version?: string;
}

export interface CmntContextType {
    scriptSrc: string;
    options: CmntOptions;
    apiKey: string;
}

export default React.createContext<CmntContextType>({scriptSrc: '', apiKey: '', options: {}});
